export default "__VITE_ASSET__BubnRDs___";